import React, { useEffect, useState } from "react";
import CTA from "./CTA";
import "./Header.css";
import ME from "../../assets/me-real.jpg";
import HeaderSocails from "./HeaderSocails";
import { BiLike } from "react-icons/bi";
import { AiFillLike } from "react-icons/ai";
import { BsFillEyeFill } from "react-icons/bs";
import { FaRegEye } from "react-icons/fa";
import axios from "axios";
import { getLike, getViewers, like } from "../../redux/like/actions";
import { useDispatch, useSelector } from "react-redux";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Text from "../text/Text";
import TextLoop from "react-text-loop";

function Header({ darkMode }) {
  const [ip, setIP] = useState("");
  const [isLike, setIsLike] = useState(false);
  const dispatch = useDispatch();
  const likeDetails = useSelector((state) => state.likes.likes);

  const getData = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    console.log(res.data);
    setIP(res.data.IPv4);
  };

  useEffect(() => {
    if (likeDetails._id) {
      dispatch(getViewers(likeDetails._id, ip));
    }

    dispatch(getLike());
    getData();
  }, [likeDetails._id]);

  const Like = async (e) => {
    e.preventDefault();
    dispatch(like(likeDetails._id, ip));
  };
  return (
    <header>
      <div
        className={
          darkMode
            ? "container header__container"
            : "container header__container light"
        }
      >
        <AnimationOnScroll animateIn="animate__bounceIn" animateOnce="true">
          <h3>Hello I'm</h3>
          <h1>Aung Kaung Myat</h1>
          <div className="who-i-am" style={{ margin: ".5rem" }}>
            <TextLoop mask={true} interval={1000}>
              <h3>Web Developer</h3>
              <h3>Web Designer</h3>
              <h3>Full Stack Web Developer</h3>
            </TextLoop>
          </div>
        </AnimationOnScroll>

        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__shakeY"
          animateOut="animate__bounceOutRight"
        ></AnimationOnScroll>
        <div className="site_reaction">
          <AnimationOnScroll
            animateIn="animate__fadeInLeftBig"
            animateOnce="true"
          >
            <div className="like_detail">
              {darkMode ? (
                <BiLike
                  className="reaction_icon reaction_like"
                  onClick={(e) => Like(e)}
                />
              ) : (
                <AiFillLike
                  className="reaction_icon reaction_like"
                  onClick={(e) => Like(e)}
                />
              )}
              <span className="like_count">
                {likeDetails.likes ? likeDetails.likes.length : "0"} reacts
              </span>
            </div>
          </AnimationOnScroll>

          <AnimationOnScroll
            animateIn="animate__fadeInRightBig"
            animateOnce="true"
          >
            <div className="view_detail">
              {darkMode ? (
                <FaRegEye className="reaction_icon" />
              ) : (
                <BsFillEyeFill className="reaction_icon" />
              )}
              <span className="view_count">
                {likeDetails.views ? likeDetails.views.length : "0"} views
              </span>
            </div>
          </AnimationOnScroll>
        </div>
        <CTA />
        <HeaderSocails darkMode={darkMode} />
        <div className="me">
          <AnimationOnScroll
            initiallyVisible={true}
            animateIn="animate__flip"
            animateOnce="true"
          >
            <img src={ME} alt="me" />
          </AnimationOnScroll>
        </div>
        <a
          href="#contact"
          className={darkMode ? "scroll__down" : "scroll__down light"}
        >
          <AnimationOnScroll
            animateIn="animate__fadeInLeftBig"
            animateOnce="true"
          >
            Scroll Down
          </AnimationOnScroll>
        </a>
      </div>
    </header>
  );
}

export default Header;
